
























































































































































































































































import Component, {mixins} from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import {Groupe, Societe} from "@/shared/Groupe";
import ErrorMixin from "@/mixins/errorMixins";
import ConfigMixin from "@/mixins/ConfigMixin";
import VueJsonToCsv from "vue-json-to-csv";
import _ from "lodash";
import {Site} from "@/shared/Site";

@Component({
  components: {VueJsonToCsv},
})
export default class Groupes extends mixins(
    MobileMixin,
    ErrorMixin,
    ConfigMixin
) {
  public search: string = "";
  public selectedGroupe: Groupe = new Groupe();
  public confirmDelete: boolean = false;
  public addGr: boolean = false;
  public editGr: boolean = false;
  public showAddSite: boolean = false;
  public showAddGr: boolean = false;
  public showExSite: boolean = false;
  public showExGr: boolean = false;
  public restaurantIds_to_enseigne: any = {};
  public restaurantIds_to_codeAlpha: any = {};

  public created() {
    this.resIdToCodeAlpha(this.restaurantIds_to_codeAlpha);
    this.resIdToEnseignes(this.restaurantIds_to_enseigne);
  }

  /**
   * methode de filtre des groupes existants correspondant au texte entrée dans le champs de recherche
   */
  public getFilteredGroupes(): Groupe[] {
    let grs = this.groupes.filter((groupe: Groupe) =>
        groupe.raisonSociale.toUpperCase().includes(this.search.toUpperCase())
    );

    if (grs.length === 0) {
      this.addGr = true;
    }

    grs = _.orderBy(grs, "raisonSociale");

    return grs;
  }

  /**
   * Création d'un nouveau groupe au click sur entrée
   * (activé quand aucun groupe de correspondant à la recherche n'est trouvé)
   */
  public onKeydown(evt: any) {
    if (evt.keyCode === 13) {
      this.selectedGroupe = new Groupe();

      if (this.search !== "") {
        this.selectedGroupe.raisonSociale = this.search;
      }

      this.selectedGroupe.$edit = true;
      this.selectedGroupe.societesPlus = [];
      this.selectedGroupe.societesMoins = [];
      this.showAddSite = false;
      this.showAddGr = false;
      this.showExSite = false;
      this.showExGr = false;

      this.editGr = true;
    }
  }

  /**
   * methode de selection du groupe selectionné
   */
  public selectGroupe(groupe: Groupe) {
    this.selectedGroupe = groupe;
    this.selectedGroupe.$edit = true;
  }

  /**
   * méthode de récupération de l'icone a afficher dans le champ de recherche
   * une loupe si on trouve des groupes correspondant
   * un plus si on ne trouve pas pour proposer l'ajout
   */
  public getIcon() {
    if (this.addGr) {
      return "icon-plus";
    } else {
      return "icon-look";
    }
  }

  /**
   * Annule les changements durant la modification
   */
  public async cancelEdit() {
    // Récupération des groupes au vrai état sans les modifications
    await this.$store.dispatch("config/getGroupes");

    // Sélectionne le groupe avec le meme id que le groupe sélectionné
    this.selectedGroupe = this.groupes.find((groupe: Groupe) => groupe.id === this.selectedGroupe.id) || new Groupe();

    // Changes les états des vues en lecture simple
    this.editGr = false;
    this.selectedGroupe.$edit = false;
  }

  /**
   * Affichage d'une message de confirmation de la suppression d'un groupe
   */
  public confirmDeleteGroupe() {
    this.confirmDelete = true;
  }

  /**
   * methode permettant d'enregistrerv/ créer le groupe selectionné
   *
   */
  public saveGroupe(groupe: Groupe) {
    if (groupe.id !== "") {
      this.updateSelectedGroupe();
    } else {
      this.addGroupe(groupe);
    }
  }

  /**
   * méthode de suppression d"un groupe
   */
  public removeGroupe(groupeToRem: Groupe) {
    this.$store.dispatch("config/removeGroupe", groupeToRem)
        .then(
            (response: any) => {
              if (response.status === 200) {
                this.selectedGroupe.$edit = false;
                this.selectedGroupe = new Groupe();
                this.confirmDelete = false;
                this.setSuccess(
                    groupeToRem.raisonSociale + " " + this.$t("deleted").toString()
                );
              }
            },
            (error: any) => {
              this.setErrorFromTxt(error.toString());
            }
        );
  }

  public extract() {
    let groupesJson = new Array();

    groupesJson = this.groupes.map((user: any) => {
      return this.transformGr(user);
    });

    return groupesJson;
  }

  /**
   * methode d'ajout d'un nouveau groupe à la bdd
   */
  private addGroupe(groupeToAdd: Groupe) {
    this.search = "";

    this.$store.dispatch("config/addGroupe", groupeToAdd)
        .then(
            () => {
              this.selectedGroupe.$edit = false;
              // console.log(response)
              this.editGr = false;
              this.$store.dispatch("login/getGroupements");
              this.setSuccess(
                  groupeToAdd.raisonSociale + " " + this.$t("added").toString()
              );
            },
            (error: any) => {
              this.setErrorFromTxt(error.toString());
            }
        );
  }

  /**
   * methode de mise à jour du groupe dans la bdd et dans le state de l'application
   */
  private updateSelectedGroupe() {
    this.$store.dispatch("config/updateOneGroupe", this.selectedGroupe)
        .then(
            () => {
              this.selectedGroupe.$edit = false;
              this.editGr = false;
              this.setSuccess(
                  this.selectedGroupe.raisonSociale +
                  " " +
                  this.$t("updated").toString()
              );
            },
            (error: any) => {
              this.setErrorFromTxt(error.toString());
            }
        );
  }

  private transformGr(gr: Groupe) {
    const obj: { [k: string]: any } = {
      raisonSociale: gr.raisonSociale,
      sites: gr.raisonsSociales,
    };

    return obj;
  }

  // computed
  get groupes(): Groupe[] {
    return this.$store.getters["config/groupes"];
  }

  get societes(): Societe[] {
    return this.$store.getters["config/societes"];
  }

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }
}
